<template>
  <div id="FueraServicio">
    <div>Chilempleo::2020</div>
    <div class="text-center col-sm-12">
      <img src="../../static/img/re.jpg" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'FueraServicio'
}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// FueraServicio.vue?524865f5